import React from 'react';
import { pdfBulletPoints, pdfInsideThePdf } from '../../data/palmistry101Content';

/**
 * PDF wiring:
 * - REACT_APP_PALMISTRY101_PDF_URL — hosted PDF URL
 * - hasAccess from palmistry101Access.hasPalmistryAccess()
 */
export default function PalmistryPdfDownload({ hasAccess, pdfUrl }) {
  const canDownload = Boolean(hasAccess && pdfUrl);
  const missingUrl = hasAccess && !pdfUrl;

  return (
    <section
      className={`amm-palmistry101-section amm-palmistry101-pdf${!hasAccess ? ' is-locked' : ''}`}
      aria-labelledby="palmistry-pdf-heading"
      id="palmistry-pdf"
    >
      <h2 id="palmistry-pdf-heading" className="amm-palmistry101-section-title">
        {hasAccess ? 'Your Palmistry Companion Guide' : 'Companion guide (included)'}
      </h2>
      <p className="amm-palmistry101-section-intro">
        {hasAccess
          ? 'A printable reference while the main learning stays on this page — not the main event, but a steady companion.'
          : 'The course includes a printable PDF for notes and quick review. You can download it as soon as you enroll.'}
      </p>

      <div className="amm-palmistry101-pdf-card">
        <h3 className="amm-palmistry101-pdf-subtitle">Inside the PDF</h3>
        <ul className="amm-palmistry101-pdf-list amm-palmistry101-pdf-inside">
          {pdfInsideThePdf.map((t, i) => (
            <li key={i}>{t}</li>
          ))}
        </ul>

        {!hasAccess && (
          <p className="amm-palmistry101-pdf-preview-note">
            These materials are bundled with Palmistry 101 so you can keep the page open for study and the PDF
            nearby for jotting.
          </p>
        )}

        <h3 className="amm-palmistry101-pdf-subtitle amm-palmistry101-pdf-subtitle-secondary">
          {hasAccess ? 'Also included' : 'At a glance'}
        </h3>
        <ul className="amm-palmistry101-pdf-list amm-palmistry101-pdf-glance">
          {pdfBulletPoints.map((t, i) => (
            <li key={i}>{t}</li>
          ))}
        </ul>

        <div className="amm-palmistry101-pdf-actions">
          {canDownload && (
            <a
              href={pdfUrl}
              className="amm-palmistry101-btn amm-palmistry101-btn-secondary"
              download
            >
              Download companion PDF
            </a>
          )}
          {missingUrl && (
            <div className="amm-palmistry101-pdf-placeholder" role="status">
              <p className="amm-palmistry101-pdf-placeholder-title">Download preparing</p>
              <p className="amm-palmistry101-pdf-note">
                {process.env.NODE_ENV !== 'production' ? (
                  <>
                    Set <code className="amm-palmistry101-code">REACT_APP_PALMISTRY101_PDF_URL</code> in the
                    client environment and redeploy.
                  </>
                ) : (
                  'Your companion PDF link will appear here once the file is connected in hosting.'
                )}
              </p>
            </div>
          )}
          {!hasAccess && (
            <p className="amm-palmistry101-pdf-note amm-palmistry101-pdf-locked-note">
              Unlocks with the course — use the enrollment section when you are ready.
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
